import { render, staticRenderFns } from "./CustAdd.vue?vue&type=template&id=06cf2dd0&scoped=true&"
import script from "./CustAdd.vue?vue&type=script&lang=js&"
export * from "./CustAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf2dd0",
  null
  
)

export default component.exports